module.exports = __webpack_public_path__ + "img/reach-entertainment.1107df5a.jpg";